import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductSdsnComponent } from './product-sdsn.component';



@NgModule({
  declarations: [ProductSdsnComponent],
  imports: [
    CommonModule
  ],
  exports: [ProductSdsnComponent]
})
export class ProductSdsnModule { }
